export default "__VITE_ASSET__Cblwkckt__"